export default __webpack_public_path__ + "5ef90b6a10be298cafbb0d5994d6e83b.png";